var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapSpinstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.167 120C99.5417 120 1 169.271 1 234.583C1 290.729 74.1042 334.958 177.688 346.417L168.063 355.813C165.915 357.943 164.21 360.478 163.046 363.27C161.883 366.063 161.284 369.058 161.284 372.083C161.284 375.109 161.883 378.104 163.046 380.897C164.21 383.689 165.915 386.224 168.063 388.354C170.193 390.502 172.728 392.207 175.52 393.37C178.313 394.534 181.308 395.133 184.333 395.133C187.359 395.133 190.354 394.534 193.147 393.37C195.939 392.207 198.474 390.502 200.604 388.354L246.438 342.521C248.524 340.341 250.159 337.771 251.25 334.958C253.542 329.379 253.542 323.121 251.25 317.542C250.159 314.729 248.524 312.159 246.438 309.979L200.604 264.146C196.289 259.831 190.436 257.406 184.333 257.406C178.231 257.406 172.378 259.831 168.063 264.146C163.747 268.461 161.323 274.314 161.323 280.417C161.323 286.519 163.747 292.372 168.063 296.687L170.813 299.208C92.6667 288.208 46.8333 257.5 46.8333 234.583C46.8333 206.625 118.333 165.833 230.167 165.833C342 165.833 413.5 206.625 413.5 234.583C413.5 253.604 380.271 280.417 317.021 294.167C314.027 294.74 311.178 295.905 308.64 297.594C306.102 299.282 303.926 301.46 302.24 303.999C300.554 306.539 299.392 309.389 298.821 312.383C298.251 315.378 298.283 318.456 298.917 321.437C299.542 324.39 300.745 327.19 302.456 329.676C304.167 332.163 306.352 334.287 308.886 335.926C311.42 337.566 314.253 338.689 317.222 339.231C320.191 339.772 323.238 339.722 326.188 339.083C409.833 320.75 459.333 281.792 459.333 234.583C459.333 169.271 360.792 120 230.167 120Z",
    fill: "#333333",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60L399.411 399.411",
    stroke: "white",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.411 60L60 399.411",
    stroke: "white",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60L399.411 399.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M399.411 60L60 399.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapSpinstop);
export default __webpack_public_path__ + "static/media/ico_map_spinstop.a8d75a495d66707d8173241db617209b.svg";
export { ForwardRef as ReactComponent };